import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { LoaderSpinnerComponent } from './loader-spinner.component'

@NgModule({
    declarations: [LoaderSpinnerComponent],
    imports: [CommonModule],
    exports: [LoaderSpinnerComponent]
})
export class LoaderSpinnerModule {}
